<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/180mREA/images/9781940013626_cover.jpg?1684514595943" alt="This image is the cover for the book Shades of Public Finance Vol. 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shades of Public Finance Vol. 2
      </h1>
      <p class="bookDescription body article font2">
        <p>Shades of Public Finance lifts the curtain on aspects of American civil and financial underpinnings that most people know little about. Local water treatment systems, state university campuses, roads, parks and many other features of our cities and states have been built with local control and local decision-making because imaginative figures like Richard Sigal found ways to turn community assets into cash through bonds. Sigal explains in clear language how bonds are structured, who gets rich, who gets stuck and how politics impacts bond financing. Sigal highlights the frightening prospect of centralized, federal control of local communities' infrastructure and growth because municipal bankruptcy has become an acceptable strategy in difficult financial times, despite workable options that preserve local creditworthiness.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Sigal
      </h2>
      
      <p class="authorDescription body article">Richard Land Sigal practiced public finance from 1964 to 2016 including fifty years with the national law firm of Hawkins Delafield &amp; Wood. He was the bond counsel or underwriters' partner in charge of major tax exempt or taxable bond issues in many states as well as the Commonwealth of Puerto Rico. A graduate of Yale University (1960) and the University of Chicago School of Law (1963), Sigal's contribution to the creation of financing strategies to support the growth of public infrastructure are unmatched. Among his most significant contributions was developing a special tax in 2006 to secure a multibillion-dollar bond issue to fund general fund deficits of the Commonwealth of Puerto Rico. That security structure withstood challenge in 2019 in the recent Puerto Rico bankruptcy and is expected to be a prime structure to finance the many new capital needs of that territory. Mr. Sigal was a two-year chairman of the New York State Bar Association – Municipal Law Section, Chairman of Bond Buyer National Conferences held in San Francisco and New York, and received the Corporate Affiliate Award for outstanding service to the profession and the National Association of State Treasurers in 2008. Mr. Sigal resides in New York City with his wife Samayla Deutch, who is also an attorney.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dudley Court Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05bf50b4